import { BaseView } from '@/components/base'
import { AnimatedArcProgressSVG } from './AnimatedArcProgressSVG'
import { ArcTextContent } from './ArcTextContent'
import { ArcProgressBarProps } from './types'

export const ArcProgressBar = (props: ArcProgressBarProps) => {
  const { size = 300, strokeWidth = 11 } = props

  return (
    <BaseView
      style={{
        width: size,
        height: 160,
        alignSelf: 'center',
        position: 'relative',
      }}
    >
      <AnimatedArcProgressSVG
        size={size}
        strokeWidth={strokeWidth}
        {...props}
      />
      <ArcTextContent size={size} {...props} />
    </BaseView>
  )
}

export type { ArcProgressBarProps }
